/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Component } from "@angular/core";

import { NzOptionItemComponent } from "ng-zorro-antd/select";

@Component({
  selector: "ui-option-item",
  templateUrl: "option-item.component.html",
  host: {
    "[attr.title]": "label",
    "[class.ant-select-item-option-grouped]": "grouped",
    "[class.ant-select-item-option-selected]": "selected && !disabled",
    "[class.ant-select-item-option-disabled]": "disabled",
    "[class.ant-select-item-option-active]": "activated && !disabled",
    "(mouseenter)": "onHostMouseEnter()",
    "(click)": "onHostClick()",
  },
})
export class UiOptionItemComponent extends NzOptionItemComponent {}
